var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"timer",class:{'warning': _vm.dangerZone}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }